<div class="container mt-4">
    <!-- Notice Templates Title with Icon -->
    <h1 class="h3 mb-2 text-gray-800"><i class="fas fa-file-alt"></i> Notice Templates</h1>
    
    <!-- Description -->
    <p class="lead">The Notice Template module allows you to create and manage templates for notifications. These templates can be used for consistent messaging across different notifications.</p>
  
    <ul class="nav nav-tabs">
       <!--  <li class="nav-item">
            <a class="nav-link active" data-toggle="tab" href="#Overview">
                <i class="fas fa-chart-bar mr-2"></i> Overview
            </a>
        </li> -->
        <li class="nav-item">
            <a class="nav-link active" data-toggle="tab" href="#List">
                <i class="fas fa-list mr-2"></i> List
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#UserManual">
                <i class="fas fa-book mr-2"></i> User Manual
            </a>
        </li>
    </ul>
  
    <div class="tab-content">
        <!-- Overview tab content -->
     <!--    <div id="Overview" class="tab-pane fade show active">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-6">
                        <ngx-charts-bar-vertical
                            [results]="barChartData"
                            [view]="[400,300]"
                            [scheme]="'cool'"
                            [gradient]="true"
                            [xAxis]="true"
                            [yAxis]="true"
                            [legend]="true"
                            [showXAxisLabel]="true"
                            [showYAxisLabel]="true"
                            xAxisLabel="Category"
                            yAxisLabel="Number of Books">
                        </ngx-charts-bar-vertical>
                    </div>
                    <div class="col-md-6">
                        <ngx-charts-pie-chart
                            [results]="pieChartData"
                            [view]="[400,300]"
                            [scheme]="'cool'"
                            [legend]="true"
                            [explodeSlices]="false"
                            [labels]="true">
                        </ngx-charts-pie-chart>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <ngx-charts-line-chart
                            [results]="lineChartData"
                            [view]="[400,300]"
                            [scheme]="'cool'"
                            [legend]="true"
                            [xAxis]="true"
                            [yAxis]="true"
                            [autoScale]="true">
                        </ngx-charts-line-chart>
                    </div>
                    <div class="col-md-6">
                        <ngx-charts-pie-chart
                            [results]="doughnutChartData"
                            [view]="[400,300]"
                            [scheme]="'cool'"
                            [legend]="true"
                            [explodeSlices]="false"
                            [doughnut]="true"
                            [labels]="true">
                        </ngx-charts-pie-chart>
                    </div>
                </div>
            </div>
        </div> -->
  
        <!-- List tab content -->
        <div id="List" class="tab-pane fade show active">
            <div class="container-fluid">
                
                <div class="card mb-4">
                    <div class="card-body">
                        <button class="btn btn-outline-primary btn-icon-split" (click)="openAddDialog()"> <span class="icon text-primary">
                            <i class="fas fa-plus"></i>
                        </span> <span class="text">Add Notice Template</span> </button>
                <button
                    
                    role="button"
                    class="btn btn-outline-warning btn-icon-split"
                    (click)="loadNoticeTemplates()"
                    >
                    <span class="icon text-warning">
                        <i class="fas fa-redo"></i>
                    </span>
                    <span class="text">Reload</span>
                    </button>
                        <div class="table-responsive">
                            <div *ngIf="loading; else loaded">
                                <div class="d-flex justify-content-center">
                                  <div class="spinner-border text-primary" role="status">
                                    <span class="sr-only">Loading...</span>
                                  </div>
                                </div>
                              </div>
                      
                              <ng-template #loaded>
                            <ngx-datatable
                                class="bootstrap"
                                [rows]="noticeTemplates"
                                [columnMode]="'force'"
                                [headerHeight]="50"
                                [footerHeight]="50"
                                [rowHeight]="'auto'"
                                [limit]="10"
                                [reorderable]="true">
                                <ngx-datatable-column name="Title" [prop]="'title'"></ngx-datatable-column>
                                <ngx-datatable-column name="Content Template" [prop]="'contentTemplate'"></ngx-datatable-column>
                                <ngx-datatable-column name="Actions">
                                    <ng-template ngx-datatable-cell-template let-row="row">
                                        <button type="button" class="btn btn-outline-primary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            Actions
                                        </button>
                                        <div class="dropdown-menu">
                                            <a class="dropdown-item"  (click)="openEditDialog(row)">
                                                <i class="fas fa-edit"></i> Edit
                                            </a>
                                            <a class="dropdown-item"  (click)="deleteNoticeTemplate(row.id!)">
                                                <i class="fas fa-trash"></i> Delete
                                            </a>
                                            <a class="dropdown-item" (click)="clone(row)">
                                                <i class="fas fa-clone"></i> Clone
                                            </a>
                                           <!--  <a class="dropdown-item" >
                                                <i class="fas fa-star"></i> Set as Default
                                            </a> -->
                                        </div>
                                    </ng-template>
                                </ngx-datatable-column>
                            </ngx-datatable>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  
        <!-- User Manual tab content -->
        <div id="UserManual" class="tab-pane custom-tab-pane">
            <!-- User Manual content here -->
            <div>
               <!-- <markdown [src]="markdownContent" [data]="markdownContent"></markdown>  -->
                <div  [innerHTML]="markdownContent"></div>
            </div>
          </div>
    </div>
</div>
